/** @format */

import React, { useState, useEffect } from 'react'
import { _$, Card, BreadcrumbItem, Split, Icon } from '@king-design/react'
import styled from 'styled-components'
import { useDeepCompareEffect } from 'react-use'
import { useParams } from 'react-router'
import MointorCrumb from 'src/components/MonitorCrumb'
import EditGraphForm from 'src/containers/MonitorDashboard/Customboard/EditGraphForm'
import {
  IMonitorGraphData,
  initEditGraphData,
  calcSelectInterval
} from 'src/containers/MonitorDashboard/Customboard/constants'
// eslint-disable-next-line max-len
import getMetricStatisticsBatch from 'src/containers/MonitorDashboard/Customboard/getMetricStatisticsBatch'
import EditGraphChart from 'src/containers/MonitorDashboard/Customboard/EditGraphChart'
import { request } from 'src/utils'
import dayjs from 'dayjs'
import API from 'src/api/ApiDashboard'
interface CustomboardGraphEditPageProps {
  className?: string
}
const CustomboardGraphEditPage: React.FC<CustomboardGraphEditPageProps> = ({ className }) => {
  const { graphId, dashboardId, dashboardName } =
    useParams<{ dashboardId: string; dashboardName: string; graphId: string }>()
  // const history = useHistory()
  const [dateTime, setDateTime] = useState<[number, number]>([
    dayjs().subtract(30, 'm').valueOf(),
    dayjs().valueOf()
  ])
  const [delayOption, setDelayOption] = useState<number[]>([])
  const [delay, setDelay] = useState<number>()
  const [formValue, setFormValue] = useState<IMonitorGraphData>()

  // 获取详情数据
  const getGraphDetails = async () => {
    const result = await request(API.DescribeDashboardGraph, {
      data: {
        DashboardId: dashboardId,
        GraphId: graphId
      }
    })
    if (result.code === 'Success') {
      setFormValue(result.data.graph)
    } else {
      setFormValue(initEditGraphData)
    }
  }

  // 初始化
  useEffect(() => {
    if (graphId === 'craete') {
      setFormValue({
        ...initEditGraphData,
        dashboardId: parseInt(dashboardId)
      })
    } else {
      getGraphDetails()
    }
    return () => {
      setFormValue(initEditGraphData)
    }
  }, [graphId])

  const { getDashboardChart, chartData } = getMetricStatisticsBatch(undefined)

  // 更新预览图表
  const updateChart = () => {
    getDashboardChart(dateTime[0], dateTime[1], delay, formValue)
  }

  // 切换周期更新图表
  useEffect(() => {
    updateChart()
  }, [delay])

  // 修改formValue
  const handleChangeForm = values => {
    const newValues = {
      ...formValue,
      ...values
    }
    setFormValue(newValues)
  }

  // 修改metrics
  const handleChangeMetrics = values => {
    handleChangeForm({
      metrics: values
    })
  }

  // 校验数据是否请求接口
  const validateForm = formValue => {
    if (formValue?.metrics?.length) {
      return formValue?.metrics.some(({ aggregator, metricKey, instances }) => {
        return aggregator && metricKey && instances?.length
      })
    }
    return false
  }

  // 重新计算delay
  useDeepCompareEffect(() => {
    validateForm(formValue) && handleDelay()
  }, [dateTime, formValue?.metrics])

  const handleDelay = (value = formValue) => {
    const [start, end] = dateTime
    if (start && end && formValue?.metrics?.length) {
      const delayArray = calcSelectInterval(start, end, [value])
      if (delay === delayArray[0]) {
        updateChart()
      } else {
        setDelay(delayArray[0])
      }
      setDelayOption(delayArray)
    }
  }

  return (
    <div className={className}>
      <MointorCrumb breadArr={[{ title: _$('Dashboard'), route: '/monitor/dashboard/home' }]}>
        <>
          <BreadcrumbItem
            className="cursor"
            to={`/monitor/dashboard/detail/private/${dashboardId}`}
          >
            {dashboardName}
          </BreadcrumbItem>
          <BreadcrumbItem>
            {graphId === 'craete' ? _$('添加监控视图') : _$('编辑监控视图')}
          </BreadcrumbItem>
        </>
      </MointorCrumb>
      <Card>
        <Split
          mode="vertical"
          min="350px"
          max="350px"
          firstSize="350px"
          // onChangeFirstSize={size => setChartHeight(size)}
          slotFirst={
            <React.Fragment>
              <EditGraphChart
                height="350px"
                chartData={chartData}
                setDateTime={setDateTime}
                delayOption={delayOption}
                delay={delay}
                setDelay={setDelay}
              />
            </React.Fragment>
          }
          slotDrag={
            <React.Fragment>
              <Icon className="ion-navicon-round" />
            </React.Fragment>
          }
          slotLast={
            <React.Fragment>
              <EditGraphForm
                formValue={formValue}
                handleChangeForm={handleChangeForm}
                handleChangeMetrics={handleChangeMetrics}
              />
            </React.Fragment>
          }
        ></Split>
      </Card>
    </div>
  )
}

export default styled(CustomboardGraphEditPage)`
  .cursor .k-item-link {
    cursor: pointer;
  }
  .k-split {
    .k-split-line-wrapper {
      height: 20px;
    }
  }
`
